(() => {
  const setAccordionItemState = (item, isActive) => {
    const header = item.querySelector('.accordion-header');
    const panelId = header?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;

    item.classList.toggle('active', isActive);
    header?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    panel?.toggleAttribute('inert', !isActive);
  };

  const initializeAccordions = (root) => {
    root.querySelectorAll('.premium-accordion').forEach((accordion) => {
      accordion.querySelectorAll('.accordion-item').forEach((item) => {
        setAccordionItemState(item, item.classList.contains('active'));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAccordions(document), { once: true });
  } else {
    initializeAccordions(document);
  }

  // Product swaps can execute this asset again; keep delegated handlers single.
  if (document.documentElement.hasAttribute('data-spp-accordion-events')) return;
  document.documentElement.setAttribute('data-spp-accordion-events', '');

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initializeAccordions(event.target);
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const header = event.target.closest('.premium-accordion .accordion-header');
    if (!header) return;

    const accordion = header.closest('.premium-accordion');
    const item = header.closest('.accordion-item');
    if (!accordion || !item) return;

    const isActive = item.classList.contains('active');
    accordion.querySelectorAll('.accordion-item').forEach((accordionItem) => {
      setAccordionItemState(accordionItem, false);
    });

    if (!isActive) setAccordionItemState(item, true);
  });

  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

    const header = event.target.closest('.premium-accordion .accordion-header');
    const accordion = header?.closest('.premium-accordion');
    if (!accordion) return;

    const headers = Array.from(accordion.querySelectorAll('.accordion-header'));
    const index = headers.indexOf(header);
    let nextIndex = index;

    if (event.key === 'ArrowDown') nextIndex = (index + 1) % headers.length;
    if (event.key === 'ArrowUp') nextIndex = (index - 1 + headers.length) % headers.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = headers.length - 1;

    event.preventDefault();
    headers[nextIndex].focus();
  });
})();
